const hostName = window.location.hostname;
let config = '';

if(hostName.includes('local') || hostName.includes('staging')){
  config = {
    endpoint: 'staging.reallygreatrate.com'
  };
}else{
  config = {
    endpoint: 'reallygreatrate.com'
  };
}

export default config;
